module.exports = __webpack_public_path__ + "img/ppt.c2701f5f.svg";